import {css, unsafeCSS} from 'lit';
import {station} from '../../../../styles/images';

// language=CSS
export const styles = css`
    :host {
        display: grid;
        grid-auto-flow: row;
        background-color: var(--color-grey-dark);
        align-content: start;
    }

    .station {
        width: 100%;
        height: 8.0625rem;
        background-image: url(${unsafeCSS(station)});
        margin-bottom: var(--padding-default);
    }

    .button {
        height: 2.56rem;
        display: grid;
        place-content: center start;
        padding: 0 var(--padding-default);
        color: white;
        cursor: pointer;
        font-size: var(--font-size-medium);
    }

    .button:hover {
        background-color: var(--color-button-hovered);
    }

    .button-active {
        background-color: var(--color-button-active) !important;
        cursor: default;
        pointer-events: none;
    }
`;
